import moment from 'moment';

export const DayEnum = { 0: 'Today', 1: 'Tomorrow' };

/*
getDayDifference : give day difference & formatted date

@params
dateString format: '2023-01-18'
*/
export const getDayInfo = dateString => {
  try {
    if (!dateString || typeof dateString !== 'string') {
      return {};
    }
    const [currDay, currMonth, currYear] = new Date()
      .toLocaleDateString()
      .split('/');
    const currDateInISOformat = `${currYear}-${currMonth}-${currDay}`;

    const paramDate = moment(dateString);
    const currDate = moment(currDateInISOformat);
    return {
      dayDifference: paramDate.diff(currDate, 'days'),
      formattedDate: paramDate.format('DD MMM YYYY'),
    };
  } catch (_) {
    return {};
  }
};


/*
getDisplayDay : return day or formatted date
eg: today || 03 Jan 2023

@params
dateString format: '2023-01-18'
*/
export const getDisplayDay = dateString => {
  const { dayDifference, formattedDate } = getDayInfo(dateString);
  if (typeof dayDifference === 'number' && dayDifference < 2) {
    return DayEnum[String(dayDifference)];
  }
  return formattedDate || '';
};


export const getFormattedSlotTime = slot => {
  const { start_time: startTime } = slot || {};
  if (startTime && typeof startTime === 'string') {
    const currDate = new Date().toISOString().split('T')[0]; // 'YYYY-MM-DD'
    const formattedSlot = moment(`${currDate}T${startTime}`).format('hh:mm A');
    return formattedSlot;
  }
  return '';
};
